export const SUPPORT_EMAIL = "sw@capitalpilot.de";

/** YubiKey 5 NFC: PIV am Rechner, NFC am iPhone. Verkauf bei Yubico, nicht bei Capital Pilot. */
export const YUBIKEY_SHOP_URL = "https://www.yubico.com/de/product/yubikey-5-nfc/";

/** iPhone-App. Öffentliche Listing-ID steht noch nicht im Store-Katalog. */
export const APP_STORE_URL = "https://apps.apple.com/de/app/capital-pilot";

export const PRICE_AT_CHECKOUT =
  "Der Preis steht auf der nächsten Seite, bevor etwas berechnet wird.";

export const PRICE_BEFORE_PAYMENT = "Preis vor der Zahlung";

export const LOTSE_PRICE = "10 € / Monat";

export function planBlurb(code: string): string {
  if (code === "advisor") {
    return "Beratung mit Freigabe. Eigene Desktop-App für Mandatsdaten.";
  }
  if (code === "ai_lotse") {
    return "Zusatz zur Mitgliedschaft. Einwilligung geben Sie in der App.";
  }
  return "Private Planung. Desktop für Windows und macOS, lokaler Tresor.";
}

export function planPriceLine(priceCopy?: string | null): string {
  const text = priceCopy?.trim();
  return text || PRICE_BEFORE_PAYMENT;
}

export function includedPoints(product: string | null): string[] {
  if (product === "ai_lotse") {
    return [
      "Zusätzlich zur Mitgliedschaft",
      "Amazon Bedrock in Stockholm (EU)",
      "Einwilligung in der App",
      "Pausiert ohne Restkontingent",
    ];
  }
  if (product === "advisor") {
    return [
      "Berater-Desktop für Windows und macOS",
      "Mandate nur mit Freigabe des Kunden",
      "Planung auf den freigegebenen Daten",
      "Updates in der installierten App",
    ];
  }
  return [
    "Desktop-App für Windows und Mac",
    "Verschlüsselt auf Ihrem Gerät statt in der Cloud",
    "Vermögen, Haushalt und Planung an einem Ort",
    "Neue Versionen direkt in der App",
  ];
}

export function deleteAccountHref(email: string | null, sub: string | null): string {
  const subject = encodeURIComponent("Konto löschen");
  const who = [email, sub ? `Konto-ID ${sub}` : null].filter(Boolean).join(", ");
  const body = encodeURIComponent(
    who ? `Bitte löschen Sie das Konto ${who}.` : "Bitte löschen Sie mein Konto.",
  );
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
}
